import axios from 'axios';
import { DocumentActionButton } from 'components/clinical-data/RequiresActionDocumentList';
import TextArea from 'components/final-form/TextArea';
import FormButtonsRow from 'components/layout/FormButtonsRow';
import FormContainer from 'components/layout/FormContainer';
import FormContent from 'components/layout/FormContent';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import PraxFormGrid from 'components/layout/PraxFormGrid';
import StyledActionButton from 'components/layout/StyledActionButton';
import React, { useRef } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Grid, Icon, Modal } from 'semantic-ui-react';
import { getPatientDocumentText } from 'services/patientRecordServices';
import styled from 'styled-components';
import { PatientCdrDocumentDto } from 'ts-types/api.types';
import { withRouterWorkaround } from 'utils/workaroundUtils';

interface Props extends MessageSourceProps {
  document: PatientCdrDocumentDto;
  handleError: (errorData: any) => void;
}

const TextModal = styled(Modal)`

  button.close-icon {
    display: block;
    float: right;
  }

`;

const CdrDocumentTextModal = (props: Props) => {

  const {getMessage} = props;

  const cancelTokenSource = useRef(axios.CancelToken.source());

  const [modalOpen, setModalOpen] = React.useState(false);

  const [text, setText] =
      React.useState<string | undefined>(undefined);

  const openModal = () => {

    const {document} =props;

    const documentId = document.documentId;
    const patientId = document.patientId;

    getPatientDocumentText(patientId, documentId, cancelTokenSource.current)
        .then(response => {
          setText(response);
          setModalOpen(true);
        })
        .catch((e: any) => props.handleError
            && e.response
            && e.response.data
            && props.handleError(e.response.data))
  }

  const closeModal = () => setModalOpen(false);

  const renderForm = () => {
    return (
        <FormContainer>
          <FormContent>
            <PraxFormGrid>
              <Grid.Row>
                <Grid.Column>
                  <label htmlFor="textContent">
                    {getMessage("patientRecord.patientDocument.uploadPatientDocument.comment")}
                  </label>
                  <Field
                      name="textContent"
                      component={TextArea}
                      style={{minHeight: "20vh", maxHeight: "70vh", height: "70vh"}}
                  />
                </Grid.Column>
              </Grid.Row>
            </PraxFormGrid>
            <FormButtonsRow>
              <div style={{float: "right"}}>
                <Button compact type="button" onClick={closeModal}>
                  {getMessage("button.cancel")}
                </Button>
              </div>
            </FormButtonsRow>
          </FormContent>
        </FormContainer>
    );
  };

  return <>
    <DocumentActionButton
        iconName="file alternate outline"
        popupMessage="patientRecord.patientDocument.document"
        onClick={() => openModal()}
    />

    {
        modalOpen
        && <TextModal
            open={modalOpen}
            onClose={closeModal}
            closeOnDimmerClick={false}
        >
          <Modal.Header>
            {getMessage("patientRecord.patientDocument.textDocument.modalHeader")}
            <StyledActionButton
                className={"close-icon"}
                type="button"
                size="large"
                compact
                onClick={closeModal}
            >
              <Icon name={"close"} />
            </StyledActionButton>
          </Modal.Header>
          <FormModalContentContainer>
            <FinalForm
                onSubmit={() => {
                }}
                initialValues={{textContent: text}}
                subscription={{pristine: true, submitting: true}}
                render={renderForm}
            />
          </FormModalContentContainer>
        </TextModal>
    }
  </>;
}

export default withRouterWorkaround(
    withMessages(
        CdrDocumentTextModal));
